/**
 * @generated SignedSource<<5572e2aa24534f20a414cdc195af9542>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sharedMessageHelpers_messages$data = {
  readonly items: ReadonlyArray<{
    readonly note: {
      readonly content: {
        readonly cta: {
          readonly text: string | null;
          readonly url: string | null;
        } | null;
        readonly message: string | null;
        readonly title: string | null;
        readonly type: string | null;
      } | null;
      readonly serviceId: string | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "sharedMessageHelpers_messages";
};
export type sharedMessageHelpers_messages$key = {
  readonly " $data"?: sharedMessageHelpers_messages$data;
  readonly " $fragmentSpreads": FragmentRefs<"sharedMessageHelpers_messages">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "sharedMessageHelpers_messages"
};

(node as any).hash = "1c1c4fdd99dd2e10007aab847734be47";

export default node;
